// extracted by mini-css-extract-plugin
module.exports = {"header":"header--_JKUr","block":"block--2HY4i","block-title":"block-title--2BUn6","btn-line":"btn-line--1pWET"};